<div class="edp-energetic-certification-autodeclaration d-flex flex-column">
    <span class="title mb-2">{{"pt.edp.edponline.request.operations.energetic.certification.docs" | translate}}</span>

    <span class="subtitle mb-2">
        {{"pt.edp.edponline.request.operations.energetic.certification.gas.doc1"| translate}}
    </span>
    <edp-drag-drop-files-upload (uploaded)="onUploadFile($event)" [maxFileSizeMB]="5"
        [filesMessageLabel]="'pt.edp.edponline.third_step.enable_attach' | translate"
        [fieldFileToToSet]="fieldFileToToSet"
        [valueFileToSet]="valueFileToSetCertification">
    </edp-drag-drop-files-upload>

    <span class="subtitle mt-4 mb-2">
        {{"pt.edp.edponline.request.operations.energetic.certification.gas.doc2"| translate}}
    </span>
    <edp-drag-drop-files-upload (uploaded)="onUploadFile($event)" [maxFileSizeMB]="5"
        [filesMessageLabel]="'pt.edp.edponline.third_step.enable_attach' | translate"
        [fieldFileToToSet]="fieldFileToToSet"
        [valueFileToSet]="valueFileToSetDeclaration">
    </edp-drag-drop-files-upload>

    <span class="title mt-1">
        {{"pt.edp.edponline.request.operations.energetic.certification.download1" | translate}}
        <a class="edp-text-seaweed-green"
            [href]="'pt.edp.edponline.request.operations.energetic.certification.download.link' | translate"
            [edpExternalLink]="'pt.edp.edponline.request.operations.energetic.certification.download.link' | translate"
            [isFile]="true">
            {{"pt.edp.edponline.request.operations.energetic.certification.download2" | translate}}
        </a>.
    </span>
</div>
